import { useSearchParams } from '@/hooks/useSearchParams';
import styles from './styles.module.scss';
import { useLuckySpinWithSelectedSpin } from '@/hooks/useLuckySpinWithSelectedSpin';

import useTranslation from 'next-translate/useTranslation';
import Color from 'color';
import { useLuckySpinsRewardsByLuckySpin } from '@/api/lucky-spin-rewards';
import { Animation } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export default function LuckySpinBanner() {
  const search: URLSearchParams = useSearchParams();
  const { t } = useTranslation('common');
  const mode: number = Number(search.get('mode') ?? 1);
  const { isLoading, error, luckySpin } = useLuckySpinWithSelectedSpin();
  const { biggestPrize, isLoading: loadingRewards } =
    useLuckySpinsRewardsByLuckySpin({
      id: luckySpin?.id,
    });

  if (error || isLoading || loadingRewards) {
    return null;
  }

  return (
    <Animation
      type="fadeInUp"
      key={`lucky-spin-banner-${mode}`}
      className={styles.container}
    >
      <h6
        className={styles.container__text}
        style={{
          //@ts-ignore
          '--rank-color': Color(String(luckySpin?.rankGroup?.color))
            .saturate(1)
            .lighten(0.2)
            .toString(),
          '--rank-color--strong': Color(String(luckySpin?.rankGroup?.color))
            .saturate(1)
            .darken(0.2)
            .toString(),
          '--rank-color--alpha': Color(String(luckySpin?.rankGroup?.color))
            .saturate(1)
            .darken(0.2)
            .alpha(0.5)
            .toString(),
        }}
      >
        {t('win_amount', {
          amount: WalletService.maskCurrency({
            amount: getMoneyOrAmount(biggestPrize?.amount),
            coin: biggestPrize?.coin,
          }),
        })}
      </h6>
    </Animation>
  );
}
